<template>
  <div class="container mx-auto">
    <div class="flex flex-wrap">
      <div class="px-4 w-full">
        <BigTitle title="Settings" class="mb-11 pt-40"/>
        <Account />
      </div>
    </div>
  </div>
</template>

<script>
  import Account from '@/components/settings/Account'
  import BigTitle from '@/components/BigTitle'

  export default {
    components: {
      Account,
      BigTitle
    },
  }
</script>

<style lang="scss" scoped>

</style>